// Libraries
import PropTypes from 'prop-types'
import React, { Component } from 'react'
// Common components
import { TableLayout } from 'Components'

// Specs
import { FireFormSpecs, PermitsTableSpecs } from 'Views/Permits/Specs'
import { Information } from '../Tabs'
import { Card } from 'antd'

class PermitsTab extends Component {
  static propTypes = {
    // Témoin d'approvisionnement des données
    loading: PropTypes.bool,
    isSubPermitLoading: PropTypes.bool,

    // Utilisateur connecté
    profile: PropTypes.object,

    // Données de la vue
    totalPermits: PropTypes.number,
    permits: PropTypes.array,
    // Fonctions hérités du constructeur
    constructorFunctions: PropTypes.objectOf(PropTypes.func),
    isDownloading: PropTypes.bool,
    openedPermit: PropTypes.object,
    onPermitChange: PropTypes.func,
    onActionDropDownOpen: PropTypes.func,
    type: PropTypes.string,
    formLayout: PropTypes.object,
    closeInformation: PropTypes.func
  }

  static defaultProps = {
    // Témoin d'approvisionnement des données
    loading: true,
    isSubPermitLoading: false,

    // Données de la vue
    totalPermits: 0,
    permits: [],
    isDownloading: false,
    openedPermit: null,
    onPermitChange: null,
    onActionDropDownOpen: null,
    type: 'firePermit',
    formLayout: FireFormSpecs
  }

  constructor(props) {
    super(props)

    this.state = {
      // données des filtres
      currentPage: 0,
      showPageSize: 10,
      sortField: 'dateCreated',
      sortOrder: 'descend',
      sortFilters: {}
    }
  }

  render() {
    const {
      loading,
      isSubPermitLoading,
      constructorFunctions,
      profile,
      totalPermits,
      permits,
      isDownloading,
      openedPermit,
      onPermitChange,
      onActionDropDownOpen,
      type,
      formLayout,
      closeInformation
    } = this.props

    // Ajout des données au tableau
    PermitsTableSpecs.rows = permits

    // Ajout des actions au clic sur un ligne du tableau
    PermitsTableSpecs.onRow = permit => {
      return {
        onClick: () => onPermitChange(permit)
      }
    }

    // Pagination
    // Nombre total de permits
    PermitsTableSpecs.pagination.total = totalPermits
    PermitsTableSpecs.totalItems = totalPermits
    // Build columns
    PermitsTableSpecs.columns = PermitsTableSpecs.getColumns({
      profile,
      constructorFunctions,
      isDownloading,
      loading: loading || isDownloading || isSubPermitLoading,
      type,
      onActionDropDownOpen: permit => {
        onActionDropDownOpen(permit)
      }
    })

    return (
      <main>
        {openedPermit == null && (
          <Card className='tab information'>
            <TableLayout loading={loading} {...PermitsTableSpecs} />
          </Card>
        )}
        {openedPermit != null && (
          <Information
            data={openedPermit}
            type={type}
            loading={loading}
            isDownloading={isDownloading}
            profile={profile}
            constructorFunctions={constructorFunctions}
            formLayout={formLayout}
            goBack={closeInformation}
          />
        )}
      </main>
    )
  }
}

export default PermitsTab
